"use strict";

require("../../style/index.less");

require("./index.less");
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/lib/button/style/index.js
// module id = 1165
// module chunks = 0